<template>
  <div>
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      showQuickJumper
      :columns="columns"
      :data="loadData"
      style="margin-top:10px;"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <!-- <span slot="startDate" slot-scope="text">{{ dateFormatB(text) }}</span> -->
      <!-- 优惠券状态 0 未使用 1 已使用 -->
      <span slot="couponStatus" slot-scope="text, record">
        <span v-if="text === '0'">Available</span>
        <span v-else>
          {{ (record.transferToCustomerCode && record.transferToCustomerCode.length > 0) ? 'Transferred' : 'Used' }}
        </span>
      </span>
    </s-table>
  </div>
</template>

<script>
import { toSTablePage } from '@/utils/util'
import STable from '@/components/table/'
import CustomerCouponApi from '@/api/api-cdb-customer-coupon'
import moment from 'moment'

export default {
  name: 'CdbCustomerCoupon',
  components: {
    STable
  },
  props: {
    record: {
      type: [Object],
      default: null,
    }
  },
  data () {
    return {
      // 保存状态
      saving: false,
      // 加载中
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      // queryParam: { customerId: this.customerId },
      // 表头
      columns :[
      {
        title: '#',
        scopedSlots: { customRender: 'serial' }
      },
      {
        title: 'Code',
        dataIndex: 'couponCode'
      },
      {
        title: 'Description',
        dataIndex: 'description'
      },
      {
        title: 'Amount',
        dataIndex: 'amount'
      },
      {
        title: 'Exp.Date',
        dataIndex: 'expirationDate',
        customRender: (text) => {
          if(text && text != null){
            return moment(text).format('MM/DD/YYYY')
          }
          return 'No'
        }
      },
      {
        title: 'Date Used',
        dataIndex: 'bkUseTime',
        customRender: (text) => {
        if(text && text != null){
          return moment(text).format('MM/DD/YYYY')
          }
          return 'No'
        }
      },
      {
        title: 'Bkg# Used',
        dataIndex: 'bkrId',
        customRender: (value) => value ? value : ''
      },
      {
        title: 'Transferable',
        dataIndex: 'transferable',
        customRender: (value) => value == '1' ? 'Yes' : 'No'
      },
      {
        title: 'Combine',
        dataIndex: 'combine',
        customRender: (value) => value == '1' ? 'Yes' : 'No'
      },
      {
        title: 'Status',
        dataIndex: 'couponStatus',
        // customRender: (value) => value == '0' ? 'Not Use' : 'Used'
        scopedSlots: { customRender: 'couponStatus' }
      },
    ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        parameter.curPage = parameter.pageNo
        return CustomerCouponApi.getAllCouponByCustomer(this.record.customerCode, Object.assign(parameter, this.queryParam))
          .then(res => {
            console.log(JSON.parse(res.data))
            return toSTablePage(JSON.parse(res.data))
          })
      },
      selectedRowKeys: [],
      selectedRows: []
    }
  },
  mounted () {
    console.log('this.record', this.record)
  },
  methods: {
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    refreshCurrentPage () {
      this.$refs.table.refresh(false)
    },
  }
}
</script>
<style lang="less" scoped>
.tour-records {
  font-weight: 500;
  font-size: 16px;
  padding: 20px 0 8px 0;
  line-height: 32px;
}
</style>